import { getToken } from "../users/service/localStorage";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";
const SESSION_KEY = "analytics_session_id";

// Uses fetch (not axios) on purpose: analytics failures (401 when logged out,
// network blips) must never reach the global axios response interceptor, which
// surfaces error snackbars to the user. Analytics must be invisible. fetch also
// keeps this module free of the axios import, so components that fire events
// stay unit-testable without pulling axios into the Jest bundle.

// Stable per-tab id used to stitch a user's events into a session.
export const getSessionId = () => {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
};

/**
 * Fire-and-forget event log. Never throws, never blocks the UI, and no-ops
 * when logged out (POST /analytics/event requires auth). Safe to call anywhere.
 */
export const trackEvent = (event, properties = {}) => {
  if (!event) return;
  try {
    // Inside the try on purpose (#209): reading the token touches local
    // storage, which throws outright in a browser with site data blocked. Left
    // outside, it made the one function that promises never to throw the thing
    // that crashed the caller.
    const token = getToken();
    if (!token) return;
    fetch(`${apiUrl}/analytics/event`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": token,
      },
      body: JSON.stringify({ event, properties, sessionId: getSessionId() }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* swallow — analytics is never allowed to affect UX */
  }
};
